import React from "react";
import GenericButton from "./GenericButton";

const BackButton = ({onClick, cssClasses, hidden = false}) => {
    return (
        <GenericButton onClick={onClick}
                       text={i18n.common.back}
                       hidden={hidden}
                       testid={'backBtn'}
                       cssClasses={cssClasses}/>
    );
};

export default BackButton;
